import * as helpers from '../../static/js/plugins/helpers';

$('body')
    .on('click', (e) => {
        const $el = $('.header__right');

        if (!$el.is(e.target) && $el.has(e.target).length === 0 && $el.is(':visible')) {
            $('.modal').fadeOut();
            $('.js-user-modal').removeClass('is-active');
            $('body').removeClass('modal-open').removeAttr('style');
            $('.modal__shadow').fadeOut();
            helpers.restoreScrollPosition();
        }
    })
    .on('click', '.js-modal-open', (e) => {
        const id = $(e.currentTarget).data('target');
        const scrollbarWidth = helpers.getBodyScrollbarWidth();

        $('.modal').fadeOut();

        $(`#${id}`).fadeIn();

        if ($(window).width() <= 1024) {
            helpers.saveScrollPosition();
            $('.modal__shadow').fadeIn();
            $('body').css({
                paddingRight: `${scrollbarWidth}px`,
            }).addClass('modal-open');
        }
    })
    .on('click', '.js-modal-close, .modal__shadow', () => {
        $('.modal').fadeOut();
        $('.header__login__user__menu').fadeOut();
        $('.js-user-modal').removeClass('is-active');
        $('body').removeClass('modal-open').removeAttr('style');
        $('.modal__shadow').fadeOut();
        helpers.restoreScrollPosition();
    });
